(() => {
  if (window.__laceupGenderHomeLoaded) return;
  window.__laceupGenderHomeLoaded = true;

  const genderFromUrl = () => new URLSearchParams(window.location.search).get('gender');

  function initGenderTabs(root = document) {
    root.querySelectorAll('[data-lu-gender-tabs]').forEach((tabs) => {
      const requested = genderFromUrl();
      const active = requested === 'dames' || requested === 'heren' ? requested : tabs.dataset.serverGender;
      tabs.querySelectorAll('[data-lu-gender-link]').forEach((link) => {
        const isActive = link.dataset.luGenderLink === active;
        link.classList.toggle('is-active', isActive);
        if (isActive) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
        link.addEventListener('click', () => localStorage.setItem('laceupGender', link.dataset.luGenderLink));
      });
      if (active) localStorage.setItem('laceupGender', active);
    });
  }

  function initRails(root = document) {
    root.querySelectorAll('[data-lu-gh-rail]').forEach((rail) => {
      if (rail.dataset.luGhReady) return;
      rail.dataset.luGhReady = 'true';
      const section = rail.closest('section');
      const step = () => Math.max(220, rail.firstElementChild?.getBoundingClientRect().width || rail.clientWidth * .75);
      section?.querySelector('[data-lu-gh-prev]')?.addEventListener('click', () => rail.scrollBy({left: -step(), behavior: 'smooth'}));
      section?.querySelector('[data-lu-gh-next]')?.addEventListener('click', () => rail.scrollBy({left: step(), behavior: 'smooth'}));
    });
  }

  function updateCartCount(count) {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) {
      const english = document.documentElement.lang.toLowerCase().startsWith('en');
      cartLink.setAttribute('aria-label', english
        ? `Cart with ${count} ${count === 1 ? 'item' : 'items'}`
        : `Winkelwagen met ${count} ${count === 1 ? 'artikel' : 'artikelen'}`);
    }
    document.querySelectorAll('[data-lu-cart-count], .lu-cart-count, #cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]').forEach((node) => {
      node.textContent = count;
      node.hidden = count < 1;
    });
  }

  function initCards(root = document) {
    root.querySelectorAll('[data-lu-gh-swatch]').forEach((swatch) => {
      if (swatch.dataset.luGhReady) return;
      swatch.dataset.luGhReady = 'true';
      swatch.addEventListener('click', () => {
        const card = swatch.closest('[data-lu-gh-card]');
        const image = card?.querySelector('.lu-gh-card__image');
        if (!image || !swatch.dataset.image) return;
        image.src = swatch.dataset.image;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = swatch.getAttribute('title') || image.alt;
        card.querySelectorAll('[data-lu-gh-swatch]').forEach((button) => button.classList.toggle('is-active', button === swatch));
      });
    });

    root.querySelectorAll('[data-lu-gh-quick-form]').forEach((form) => {
      if (form.dataset.luGhReady) return;
      form.dataset.luGhReady = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const status = form.querySelector('[data-lu-gh-quick-status]');
        const button = form.querySelector('button[type="submit"]');
        if (status) status.textContent = 'Even toevoegen…';
        if (button) button.disabled = true;
        try {
          const drawer = document.querySelector('cart-drawer');
          const data = new FormData(form);
          if (drawer?.getSectionsToRender) {
            data.append('sections', drawer.getSectionsToRender().map((section) => section.id));
            data.append('sections_url', window.location.pathname);
            drawer.setActiveElement?.(document.activeElement);
          }
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json'},
            body: data,
          });
          if (!response.ok) throw new Error('add_failed');
          const added = await response.json();
          if (drawer?.renderContents && added.sections) drawer.renderContents(added);
          const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((result) => result.json());
          updateCartCount(cart.item_count || 0);
          if (status) status.textContent = 'Toegevoegd aan je winkelwagen.';
          document.dispatchEvent(new CustomEvent('cart:refresh', {detail: {cart}}));
          window.setTimeout(() => { form.closest('details')?.removeAttribute('open'); }, 900);
        } catch (_error) {
          if (status) status.textContent = 'Kies een geldige variant en probeer opnieuw.';
        } finally {
          if (button) button.disabled = false;
        }
      });
    });
  }

  function initAcquisitionWidgetClearance() {
    if (document.documentElement.dataset.luGhWidgetClearance) return;
    document.documentElement.dataset.luGhWidgetClearance = 'true';
    let queued = false;
    const sync = () => {
      document.documentElement.classList.toggle('lu-gh-widget-scrolled', window.scrollY > 160);
      queued = false;
    };
    window.addEventListener('scroll', () => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(sync);
    }, {passive: true});
    sync();
  }

  function init(root = document) {
    initGenderTabs(root);
    initRails(root);
    initCards(root);
    initAcquisitionWidgetClearance();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
